
export enum LoadState {
  Idle = 'idle',
  Loading = 'loading',
  Loaded = 'loaded',
  Errored = 'errored'
}
